import { render, staticRenderFns } from "./editTeacher.vue?vue&type=template&id=f6e4d2b6&scoped=true&"
import script from "./editTeacher.vue?vue&type=script&lang=js&"
export * from "./editTeacher.vue?vue&type=script&lang=js&"
import style0 from "./editTeacher.vue?vue&type=style&index=0&id=f6e4d2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e4d2b6",
  null
  
)

export default component.exports